import { Box, DialogContentText, LinearProgress } from "@mui/material";
import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { HoldingDialog } from "./holding-dialog";

export const CommunicationHoldingDialog: FC<{
  format: string;
  pageReady: boolean;
}> = ({ format, pageReady }) => {
  const { t } = useTranslation();

  return (
    <HoldingDialog
      pageReady={pageReady}
      dialogTitle={t(`We're generating your ${format} with AI`)}
      continueButtonText={t("Continue to image selection")}
    >
      <>
        <DialogContentText mb={2}>
          {t("Please check the images and text we've generated, as AI results can vary.")}
        </DialogContentText>
        <DialogContentText>
          {t(
            `You can select an image for your ${format} now, and make further edits in the final step.`,
          )}
        </DialogContentText>
        <Box mt={4} display="flex" justifyContent="center">
          <LinearProgress variant="indeterminate" sx={{ width: "100%", maxWidth: 200 }} />
        </Box>
      </>
    </HoldingDialog>
  );
};
